module.exports = __webpack_public_path__ + "img/default_home.bece1ec9.png";